import { Link } from 'react-router'
import { Landmark } from 'lucide-react'
import { ReportsMenu } from './ReportsMenu'
import { UserMenu } from './UserMenu'

/** Brand bar with the home link, the LPC Reports (Excel export) menu and sign-in. */
export function AppHeader() {
  return (
    // Focus rings in the header are white: the brand-blue ring would vanish on the blue bar
    <header className="bg-primary text-primary-foreground [--ring:var(--primary-foreground)]">
      <div className="flex h-[72px] items-center gap-4 px-5">
        <Link
          to="/"
          className="flex min-w-0 items-center gap-2 text-xl font-semibold tracking-tight sm:text-[32px] sm:leading-8"
        >
          <Landmark className="size-6 shrink-0 sm:size-7" aria-hidden="true" />
          <span className="truncate">CoreDataStore</span>
        </Link>

        <nav className="ml-auto flex shrink-0 items-center" aria-label="Main">
          <ReportsMenu />
          <UserMenu />
        </nav>
      </div>
    </header>
  )
}
